"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MonthlyCustomerOverviewMock {
    constructor() {
        this.getMonthlyCustomerOverview = (_year, _month) => {
            return Promise.resolve([
                {
                    id: 1,
                    name: "John Doe",
                    isCoachMember: true,
                    events: [
                        {
                            eventName: "original",
                            startDate: "2021-10-01",
                            endDate: "2021-10-21",
                            days: 20,
                            reasonStart: "start period",
                            reasonEnd: "change coach",
                        },
                    ],
                },
                {
                    id: 2,
                    name: "Mia Doe",
                    isCoachMember: false,
                    events: [
                        {
                            eventName: "premium",
                            startDate: "2021-10-15",
                            endDate: "2021-10-23",
                            days: 7,
                            reasonStart: "start period",
                            reasonEnd: "change coach",
                        },
                    ],
                },
            ]);
        };
    }
}
exports.default = MonthlyCustomerOverviewMock;
//# sourceMappingURL=MonthlyCustomerOverview.js.map